import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LandingPage } from "@/pages/LandingPage";
import translations from "@/translations";

function App() {
  const [lang, setLang] = useState("pt");

  useEffect(() => {
    // Check localStorage first
    const saved = localStorage.getItem("lang");
    if (saved === "pt" || saved === "en") {
      setLang(saved);
      return;
    }
    
    // Detect browser language
    const browserLang = navigator.language || navigator.userLanguage || "";
    if (browserLang.toLowerCase().startsWith("pt")) {
      setLang("pt");
    } else {
      setLang("en");
    }
  }, []);

  const changeLang = (newLang) => {
    setLang(newLang);
    localStorage.setItem("lang", newLang);
    document.documentElement.lang = newLang;
  };

  const t = translations[lang];

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage t={t} lang={lang} changeLang={changeLang} />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
